import axios from 'axios'
import Cookies from 'js-cookie'
import {APP_ENV, TOKEN_DEVELOP, VEUS_COMPANY_ID, VEUS_PERFIL, VWS_URL, SUB_DOMAIN, VS_URL} from "@/providers/EnvironmentProvider";

if (APP_ENV === 'develop') {
    Cookies.set('vws_token', 'Bearer ' + TOKEN_DEVELOP, 5)
    Cookies.set('veus_nm_usuario', 'Veus Root Develop', 5)    
    Cookies.set('veus_usuario_id', '1', 5)
    Cookies.set('vws_veus_company_id', VEUS_COMPANY_ID, 5)
    Cookies.set('vws_veus_perfil', VEUS_PERFIL, 5)
}

axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept'

const $axios = axios.create({
    baseURL: VWS_URL + '/api/v1/'
})

$axios.interceptors.request.use(
    config => {
        const token = Cookies.get('vws_token')
        if (!token) {
            Cookies.remove('vws_token', {path: '/', domain: SUB_DOMAIN})
            Cookies.remove('veus_nm_usuario', {path: '/', domain: SUB_DOMAIN})
            Cookies.remove('veus_usuario_id', {path: '/', domain: SUB_DOMAIN})
            Cookies.remove('vws_veus_company_id', {path: '/', domain: SUB_DOMAIN})
            window.location = VS_URL
        }
        config.headers['Authorization'] = token
        config.headers['X-Veus-Usuario-Id'] = Cookies.get('veus_usuario_id')        
        config.headers['X-Veus-Nm-Usuario'] = Cookies.get('veus_nm_usuario')
        config.headers['X-Veus-Company-Id'] = Cookies.get('vws_veus_company_id')

        return config
    },
    error => {
        Promise.reject(error)
    }
);

$axios.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        const originalRequest = error.config
        if (error.response && error.response.status === 401) {
            Cookies.remove('vws_token', {path: '/', domain: SUB_DOMAIN})
            Cookies.remove('veus_nm_usuario', {path: '/', domain: SUB_DOMAIN})
            Cookies.remove('vws_veus_company_id', {path: '/', domain: SUB_DOMAIN})
            window.location = VS_URL
        }
        return Promise.reject(error)
    }
);

export default $axios;
export const axiosbase = axios.create({
    baseURL: VWS_URL
});
export const axiosNative = axios.create();
